module.exports = __webpack_public_path__ + "static/DC3-dfb4786903ee9654eb6ad8783203f6b9.jpg";